module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("填写报名信息-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    staticClass: "orderA"
  }, [_c('div', {
    staticClass: "cost"
  }, [_c('p', {
    staticClass: "detail"
  }, [_vm._v("费用明细")]), _vm._v(" "), _c('ul', {
    staticClass: "detailText"
  }, [(_vm.zhOrderList.price_type == '市场价' ? false : true) ? _c('li', [_vm._v("市场价"), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.old_price))])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.zhOrderList.price_type)), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.market_price))])]), _vm._v(" "), _c('li', [_vm._v("报名人数"), _c('span', [_vm._v("×" + _vm._s(_vm.number))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coupon),
      expression: "coupon"
    }]
  }, [_vm._v("优惠券"), _c('span', [_vm._v(_vm._s(_vm.zhOrderList.couponprice))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scholarship),
      expression: "scholarship"
    }]
  }, [_vm._v("抵扣奖学金"), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.scholarship))])]), _vm._v(" "), _c('li', [_vm._v("学费抵扣"), _c('b', {
    staticClass: "integral"
  }, [_vm._v("(积分-" + _vm._s(_vm.zhOrderList.integral) + ")")]), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.tuitionsum))])])]), _vm._v(" "), _c('p', {
    staticClass: "money1"
  }, [_vm._v("实付金额"), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "orderHader"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "headerRight"
    }, [_c('h1', {
      staticClass: "article"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "address"
    }, [_vm._v("开班地点：" + _vm._s(item.address))]), _vm._v(" "), _c('p', {
      staticClass: "starTime"
    }, [_vm._v("开班时间：" + _vm._s(item.classes_begin) + "至" + _vm._s(item.classes_end))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "student"
  }, [_c('b', [_vm._v("学员信息")]), _c('span', {
    staticClass: "bitian"
  }, [_vm._v("(必填)")]), _vm._v("   已报名人数："), _c('span', {
    staticClass: "renshuo"
  }, [_vm._v(" " + _vm._s(_vm.number) + " ")]), _vm._v("人\n            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "add"
    }
  }, [(_vm.studentsList.length !== 0) ? _c('ul', {
    staticClass: "info-choice"
  }, _vm._l((_vm.studentsList), function(item, index) {
    return _c('li', {
      class: [item.display ? '' : 'ceshi'],
      on: {
        "click": function($event) {
          _vm.infoChoice(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.ceshi), function(item) {
    return _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "people"
    }, [_c('span', [_vm._v(_vm._s(item))])]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), (_vm.pinyin) ? _c('p', [_c('span', [_vm._v("护照英文姓")]), _c('input', {
      staticClass: "zhFight",
      attrs: {
        "type": "text"
      }
    }), _c('span', {
      staticClass: "zhPin"
    }, [_vm._v("护照英文名")]), _c('input', {
      staticClass: "zhFight zhSecond_name",
      attrs: {
        "type": "text"
      }
    }), _c('i', {
      staticClass: "error1",
      staticStyle: {
        "margin-left": "0px"
      }
    })]) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (_vm.zhOverseas) ? _c('p', {
      staticClass: "oversea"
    }, [_c('span', [_vm._v("护照号")]), _c('input', {
      staticClass: "zhPassportHZ",
      attrs: {
        "type": "text"
      }
    }), _c('i', {
      staticClass: "error"
    })]) : _vm._e(), _vm._v(" "), (_vm.zhOverseas) ? _c('p', {
      staticClass: "zhSpecial"
    }, [_c('span', {
      staticClass: "zhP"
    }, [_vm._v("护照有效期")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('DatePicker', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "date",
        "placeholder": "请选择护照有效期"
      }
    })], 1), _vm._v(" "), _c('i', {
      staticClass: "error"
    })], 1) : _vm._e(), _vm._v(" "), _vm._m(2, true), _vm._v(" "), (_vm.interval == 1 ? true : false) ? _c('p', {
      staticClass: "zhSpecial renzhi"
    }, [_c('span', {
      staticClass: "zhP"
    }, [_vm._v("任职机构")]), _c('input', {
      staticClass: "passport zhPassport1",
      attrs: {
        "type": "text"
      }
    }), _c('i', {
      staticClass: "error"
    })]) : _vm._e(), _vm._v(" "), (_vm.interval == 1 ? true : false) ? _c('p', {
      staticClass: "zhiwu"
    }, [_c('span', [_vm._v("职务")]), _c('input', {
      staticClass: "passport zhJigou",
      attrs: {
        "type": "text"
      }
    }), _c('i', {
      staticClass: "error"
    })]) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true)])
  })], 2), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "kong"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('p', {
    staticClass: "contactText"
  }, [_vm._v("让我们联系到您"), _c('span', {
    staticClass: "bitian"
  }, [_vm._v("(必填)")]), _c('span', {
    staticClass: "yes-up",
    on: {
      "click": function($event) {
        _vm.contactsList = !_vm.contactsList
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/yes-up.png")
    }
  }), _c('span', [_vm._v("更换联系人")])])]), _vm._v(" "), _c('p', {
    staticClass: "tt1"
  }, [_c('span', [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkmanLis.name),
      expression: "linkmanLis.name"
    }],
    staticClass: "addName",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkmanLis.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkmanLis.name = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tt2"
  }, [_c('span', [_vm._v("手机号")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkmanLis.phone),
      expression: "linkmanLis.phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkmanLis.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkmanLis.phone = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "error"
  }), _c('input', {
    staticClass: "contactId",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.linkmanLis ? _vm.linkmanLis.id : ''
    }
  })]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discount),
      expression: "discount"
    }],
    staticClass: "discount"
  }, [_c('p', {
    staticClass: "discountText"
  }, [_vm._v("优惠信息")]), _vm._v(" "), _c('div', {
    staticClass: "couponValue"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couponValue),
      expression: "couponValue"
    }]
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.conpons.filter(function (coupon) { return coupon.useaccess == 1; })), function(coupon, index) {
    return _c('div', {
      staticClass: "couponPicture"
    }, [_c('div', {
      staticClass: "VouchersLeft1",
      on: {
        "click": function($event) {
          _vm.selected(coupon, index)
        }
      }
    }, [_c('div', {
      staticClass: "amountNumbert"
    }, [_c('span', [_vm._v(_vm._s(coupon.price))]), _vm._v(" 元"), _c('i', [_vm._v(_vm._s(coupon.name))])]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime"
    }, [_vm._v("满" + _vm._s(coupon.condition) + "可以使用")]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime"
    }, [_vm._v("有效期：" + _vm._s(coupon.time_out))])]), _vm._v(" "), _c('div', {
      staticClass: "Marquee"
    }, [_c('div', {
      staticClass: "CancelCheck",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.quxiao(coupon, index)
        }
      }
    }, [_vm._v("取消勾选")])]), _vm._v(" "), _c('div', {
      staticClass: "mask"
    })])
  }), _vm._v(" "), _vm._l((_vm.conpons.filter(function (coupon) { return coupon.useaccess == 0; })), function(coupon) {
    return _c('div', {
      staticClass: "couponPicture1"
    }, [_c('div', {
      staticClass: "VouchersLeft1"
    }, [_c('div', {
      staticClass: "amountNumbert Voucher"
    }, [_c('span', [_vm._v(_vm._s(coupon.price))]), _vm._v(" 元"), _c('i', [_vm._v(_vm._s(coupon.name))])]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime Voucher"
    }, [_vm._v("满" + _vm._s(coupon.condition) + "可以使用")]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime Voucher"
    }, [_vm._v("有效期：" + _vm._s(coupon.time_out))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "kong"
  }), _vm._v(" "), _c('ul', {
    staticClass: "burse"
  }, [_c('li', [_c('div', {
    staticClass: "jiang"
  }, [(_vm.zhtoggle) ? _c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('li', [_vm._v("使用奖学金抵扣")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "qian"
  }, [_vm._v(_vm._s(_vm.zhOrderList.scholarship_n))])])]), _vm._v(" "), _c('div', {
    staticClass: "shuo",
    staticStyle: {
      "margin-left": "40px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n              你共有 " + _vm._s(_vm.zhOrderList.max_scholarship) + " 元奖学金，本单最高可用 " + _vm._s(_vm.zhOrderList.scholarship_n) + " 元奖学金抵扣 " + _vm._s(_vm.zhOrderList.scholarship_n) + " 元\n            ")])], 2), _vm._v(" "), _c('ul', {
    staticClass: "burse"
  }, [_c('li', [_c('div', {
    staticClass: "xue",
    on: {
      "click": _vm.xuefei
    }
  }, [(_vm.zhtoggleX) ? _c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('li', [_vm._v("使用学费抵扣   ")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "qian"
  }, [_vm._v(_vm._s(_vm.zhOrderList.tuitionsum))])]), _vm._v(" "), _c('li', {
    staticClass: "shuo"
  }, [_vm._v("你共有 " + _vm._s(_vm.zhOrderList.tuitionsum_all) + " 元学费（含积分" + _vm._s(_vm.zhOrderList.integral_all) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "kong"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('ul', {
    staticClass: "read"
  }, [_c('li', [_c('div', {
    staticClass: "yue"
  }, [(_vm.zhtoggle1) ? _c('Icon', {
    staticClass: "chang",
    attrs: {
      "type": "checkmark-round"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('li', [_vm._v("我已阅读并同意"), _c('a', {
    staticClass: "zhxieyi",
    on: {
      "click": _vm.zhxieyi
    }
  }, [_vm._v("《报名须知》")])]), _vm._v(" "), _c('li', {
    staticClass: "paid"
  }, [_vm._v("实付金额："), _c('span', [_vm._v("￥" + _vm._s(_vm.zhOrderList.price < 0 ? 0.00 : _vm.zhOrderList.price))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "zhCommit",
    attrs: {
      "disabled": _vm.zanting
    },
    on: {
      "click": _vm.zhCommit
    }
  }, [_vm._v("立即申请")])])])])])]), _vm._v(" "), _c('Bottom'), _vm._v(" "), (_vm.orderList || _vm.contactsList) ? _c('List', {
    attrs: {
      "order-list": _vm.orderList,
      "contacts-list": _vm.contactsList
    },
    on: {
      "linkman": function($event) {
        _vm.linkman($event)
      },
      "cha": function($event) {
        _vm.cha($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("姓名")]), _c('input', {
    staticClass: "addName",
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhSpecial"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("证件号码")]), _c('select', {
    staticClass: "Certificates"
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("身份证")]), _c('option', [_vm._v("护照")]), _c('option', [_vm._v("台胞证")]), _c('option', [_vm._v("回乡证")])]), _c('input', {
    staticClass: "identity",
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("手机")]), _c('input', {
    staticClass: "phone",
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    staticClass: "infoId",
    attrs: {
      "type": "hidden"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delate"
  }, [_c('span', [_vm._v("－")]), _vm._v("删除")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "addstu"
  }, [_c('span', [_vm._v("＋")]), _vm._v("添加学员")]), _vm._v(" "), _c('p', [_vm._v("超过5个学员报名建议联系客服")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tt3"
  }, [_c('i', {
    staticClass: "error"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "voucher"
  }, [_vm._v("优惠券"), _c('span', [_vm._v("（部分优惠不能叠加使用）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcf6ef8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order.vue
// module id = 561
// module chunks = 1